<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <h3 class="modal-title">Extract a full page</h3>

          <div class="modal-body">
            <slot name="body">
              <form>
                <!-- extract current page -->
                <div class="form-check">
                  <input type="radio" value="extractCurrentPage" id="extractCurrentPage" v-model="checked"/>
                  <label class="form-check-label" for="extractCurrentPage">
                    Extract current page
                  </label>
                </div>

                <!-- extract specified page -->
                <div class="form-check">
                  <input type="radio" value="extractPage" id="extractPage" v-model="checked"/>
                  <label class="form-check-label" for="extractPage">Extract page</label>
                  <input type="text" class="form-control"
                         @focus="autoCheck('extractPage')"
                         v-model="extractPage" />
                </div>

                <!-- extract from <page> to <page> -->
                <!--<div class="form-check">-->
                  <!--<input type="radio" value="extractBetween" id="extractBetween" v-model="checked"/>-->
                  <!--<label class="form-check-label" for="extractBetween">-->
                    <!--Extract from-->
                  <!--</label>-->
                  <!--<input type="text" class="form-control"-->
                         <!--@focus="autoCheck('extractBetween')"-->
                         <!--v-model="extractFromPage" required/>-->

                  <!--<label class="form-check-label" for="extractTo">to</label>-->

                  <!--<input type="text" id="extractTo" class="form-control"-->
                         <!--@focus="autoCheck('extractBetween')" v-model="extractToPage" required/>-->
                <!--</div>-->
              </form>

            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button class="modal-default-button btn" style="background-color: #d9534f" @click="$emit('close')">Cancel</button>
              <button class="modal-default-button btn" @click="getPages">
                Confirm
              </button>
            </slot>
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: "PdfEntirePageExtraction",
    data() {
      return {
        checked: 'extractCurrentPage',
        extractFromPage: '',
        extractToPage: '',
        extractPage: '',
      }
    },
    methods: {
      autoCheck(check) {
        this.checked = check;
      },

      /* Get pages to extract */
      getPages() {
        if (this.checked === 'extractCurrentPage') {
          this.$emit('extractCurrentPage', -1);
        }
        else if (this.checked === 'extractPage') {
          if (this.extractPage) {
            this.$emit('extractCurrentPage', this.extractPage);
          }
        }
        else if (this.checked === 'extractBetween') {
          if (this.extractFromPage && this.extractToPage) {
            this.$emit('extractPages', this.extractFromPage, this.extractToPage);
          }
        }
        this.$emit('close');

      }
    },

  }
</script>

<style scoped lang="scss">
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 400px;
    margin: 0 auto;
    padding: 20px 10px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
  }

  .modal-title {
    font-size: 16px;
    text-align: center;
  }

  .modal-body {
    margin: 10px 0;
    font-size: 1.0rem;
  }

  .modal-footer {
    padding: 10px 10px 0;
  }

  .modal-default-button {
    float: right;
    background-color: #2196F3;
    color: #ffffff;
    padding: 5px 10px;
    font-size: 14px;

    &:hover {
      background-color: #0060ff;
    }
  }

  /*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  .form-check {
    display: flex;
    flex-direction: row;
    margin-bottom: 5px;
    input[type=text] {
      width: 80px;
      margin-left: 10px;
      font-size: 12px;
      height: 25px;
    }
    label {
      font-size: 14px;
      margin-left: 5px;
    }
    input[type=radio] {
      height: 10px;
    }
  }

  @media only screen and (max-width: 768px) {
    .modal-container {
      width: 100%;
    }
  }
</style>